<template>
  <v-app style="height: 70px">
    <!-- Navigation -->
    <nav
      class="main-header navbar navbar-expand bg-white navbar-light border-bottom"
      style="z-index: 200 !important"
    >
      <ul class="navbar-nav ml-auto hide-scrollbar">
        <li class="nav-item" style="top: -5px">
          <div class="nav-link d-flex" data-widget="pushmenu" role="button">
            <em class="bi bi-justify position-absolute" style="z-index: 2"></em>
          </div>
        </li>
        <div v-if="backToModerUrl && !isModerRole" class="m-0">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                class="ma-2"
                text
                icon
                color="red lighten-2"
                v-bind="attrs"
                v-on="on"
                @click="redirectToTheModerDashboard"
              >
                <v-icon>keyboard_return</v-icon>
              </v-btn>
            </template>
            <span>Click To Return To The Moderation Dashboard</span>
          </v-tooltip>
        </div>
        <!-- Dropdown -->
        <v-menu
          class="d-flex"
          :close-on-click="true"
          :close-on-content-click="false"
          style="z-index: 9999"
          v-if="!isModerRole && !isUserRole"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              style="text-overflow: ellipsis"
              class="m-0 p-2 d-inline overflow-hidden font-weight-lighter"
              dark
              v-bind="attrs"
              v-on="on"
              v-cloak
            >
              {{ getDomainUrl($route.params.id) || "Select Domain" }}
            </v-btn>
          </template>
          <v-list class="overflow-auto" style="max-height: 200px">
            <!-- <router-link
              tag="v-list-item"
              class="d-flex justify-content-flex-start flex-row"
              style="color: #000000d6"
              :to="{ name: 'NewWebsite' }"
              ><em class="bi-plus-lg mr-2"></em
              ><v-list-item-title
                >Add New Website</v-list-item-title
              ></router-link
            > -->
            <router-link
              tag="v-list-item"
              class="d-flex justify-content-flex-start flex-row-reverse"
              style="color: #000000d6; justify-content: flex-end"
              :to="{ name: 'Dashboard' }"
              ><v-list-item-title>All Websites</v-list-item-title></router-link
            >
            <input
              type="text"
              class="ml-4"
              tabindex="-1"
              style="height: 35px"
              v-model="search"
              placeholder="Search"
            />
            <router-link
              tag="v-list-item"
              style="cursor: pointer"
              v-for="domain in filteredDomains"
              :key="domain.id"
              :id="domain.id"
              :to="{ name: 'MainCont', params: { id: domain.id } }"
            >
              <v-list-item-title>{{
                domain.url.split("https://")[1] || domain.url
              }}</v-list-item-title>
            </router-link>
          </v-list>
        </v-menu>
        <!-- Support -->
        <!-- <li>
          <a href="">Support</a>
        </li> -->
        <!-- My Account Menu -->
        <v-menu
          open-on-hover
          offset-y
          transition="slide-y-transition"
          bottom
          style=""
        >
          <template v-slot:activator="{ on, attrs }">
            <!-- <v-btn
              dark

              class="ml-0"
              style="font-size: 9px; height: 32px; background: #007bff"
            >
              My Account
            </v-btn> -->
            <v-btn
              v-bind="attrs"
              v-on="on"
              class="width-fit-content mr-3"
              style="height: 34px !important"
              color="primary"
              elevation="2"
              x-small
              >My Account</v-btn
            >
          </template>
          <v-list>
            <!-- <v-list-item>
              <router-link tag="v-list-item-title" :to="{ name: 'Profile' }"
                >Profile</router-link
              >
            </v-list-item> -->
            <!-- <v-list-item>
              <router-link tag="v-list-item-title" :to="{ name: 'Billing' }"
                >Billing</router-link
              >
            </v-list-item> -->
            <!-- <v-list-item>
              <router-link tag="v-list-item-title" :to="{ name: 'Upgrade' }"
                >Upgrade</router-link
              >
            </v-list-item> -->
            <router-link
              tag="v-list-item-title"
              :to="{ name: 'ChangePassword' }"
            >
              <v-list-item> Change Password </v-list-item>
            </router-link>
            <v-list-item @click="logoutMethod">
              <v-list-item-title>Log out</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </ul>
    </nav>
    <transition
      enter-active-class="animate__animated animate__fadeIn animate__faster"
      leave-active-class="animate__animated  animate__fadeOut animate__faster"
    >
      <FailureSnackbar
        v-if="failure"
        :message="failureText"
        @update-failure="handleUpdateToFailureSnackbar"
      />
    </transition>
  </v-app>
</template>

<script>
//import User from "../../apis/User";
import { mapActions } from "vuex";
//import "../../assets/styles/main.css";
import { mapState, mapGetters } from "vuex";
//import "bootstrap/dist/css/bootstrap.min.css";
import User from "../../apis/User.js";
import FailureSnackbar from "../popUps/FailureSnackbar.vue";
import Cookie from "js-cookie";

import common from "../../mixins/common";

export default {
  mixins: [common],
  components: {
    FailureSnackbar,
  },
  data() {
    return {
      search: "",
      backToModerUrl: null,
      failure: false,
      failureText: "",
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.user.user,
      domains: (state) => state.domain.domains,
    }),
    ...mapGetters(["getDomainUrl", "roles"]),
    filteredDomains() {
      return this.domains.filter((p) => {
        return (
          (p.url && p.url.toLowerCase().includes(this.search.toLowerCase())) ||
          p.id == this.search
        );
      });
    },
    isUserRole() {
      return this.roles.includes("user");
    },
    isModerRole() {
      return this.roles.includes("moder");
    },
  },
  created() {
    if (!this.isUserRole && this.isModerRole) {
      this.show();
    }
  },
  watch: {
    "$route.name": {
      handler(routeName) {
        if (!this.isModerRole) {
          this.backToModerUrl =
            Cookie.get("backToModerUrl") || this.user.backToModerUrl;
        }
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions(["logout", "getClientDomains", "show", "auth"]),
    redirectToTheModerDashboard() {
      localStorage.setItem("moderToUser", false);
      const url = this.backToModerUrl;
      const regex = /\/(\d+)$/;
      const match = url.match(regex);

      //this.$router.push({ name: "ModerMainCont" });

      User.logoutFromUser(match[1])
        .then(() => {
          Cookie.remove("backToModerUrl", { path: "/", domain: ".pushmyroi.com" });

          this.backToModerUrl = null;

          this.auth()
            .then(() => {
              setTimeout(() => {
                this.$router.replace({ path: "/moderation-dashboard" });
              }, 1500);
            })
            .catch((error) => {
              if (error.response) {
                error.response.data.message;

                this.failureText = "Error: " + error.response.data.message;
              } else {
                this.failureText = "Error";
              }

              this.failure = true;
            });
        })
        .catch((error) => {
          if (error.response) {
            error.response.data.message;

            this.failureText = "Error: " + error.response.data.message;
          } else {
            this.failureText = "Error";
          }

          this.failure = true;
        });
    },
    logoutMethod() {
      this.logout().then(() => {
        localStorage.removeItem("auth");
        this.$router.push({ name: "Home" });
      });
    },
  },
};
</script>

<style>
.v-btn.v-btn--is-elevated {
  max-width: 200px;
}
.v-list-item__title.router-link-exact-active {
  color: #c6cfbd !important;
}
.v-list-item {
  cursor: pointer;
}
.navbar-nav.ml-auto li div {
  color: #6c757d;
}
#dropdown:hover > ul {
  display: block;
}
#dropdown-menu .router-link-exact-active {
  color: #007bff !important;
}
.bi-plus-lg {
  top: 13px;
  left: 13px;
}
select.dropdown:focus,
select.dropdown {
  text-overflow: ellipsis;
  width: 160px;
}
select.dropdown {
  background: #6c706e !important;
  text-align: center;
  padding: 4px;
  border-radius: 5px;
  color: #fff;
}
.dropdown-menu.show a,
.dropdown-menu.show option {
  color: #000 !important;
}
#dropdownMenuLink {
  text-overflow: ellipsis;
  overflow: hidden;
}
.dropdown {
  color: #fff;
}
.v-btn__content {
  max-width: 150px;
  display: inline !important;
  text-overflow: ellipsis;
  overflow: hidden;
}
@media (max-width: 1023px) {
  .dropdown.show {
    position: inherit;
  }
}
@media (max-width: 540px) {
  .v-btn__content {
    max-width: 60px;
  }
  .v-btn.v-btn--is-elevated {
    max-width: 85px;
  }
  #dropdownMenuLink {
    max-width: 110px;
  }
  #dropdown {
    width: 86px !important;
  }
}
@media (max-width: 280px) {
  #dropdownMenuLink {
    max-width: 100px;
  }
  #dropdown {
    width: 54px !important;
  }
}
</style>
